export default "__VITE_ASSET__bbdd2fcc__"